var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, List } from "@chakra-ui/react";
export var PageNumberButtons = function (_a) {
    var pageCursors = _a.pageCursors, pageClickHandler = _a.pageClickHandler;
    var buttons = Array.from(pageCursors.entries())
        .sort(function (a, b) { return a[0] - b[0]; })
        .map(function (pageCursor) {
        var pageNumber = pageCursor[0], cursor = pageCursor[1];
        var isActive = cursor === "";
        return (_jsx(List.Item, { children: _jsx(Button, __assign({ "aria-current": isActive ? "page" : undefined, "aria-label": "Page ".concat(pageNumber), className: isActive ? "active" : undefined, onClick: isActive ? undefined : function (event) { return pageClickHandler(event, cursor); }, variant: "pagination" }, { children: pageNumber })) }, pageNumber));
    });
    return _jsx(_Fragment, { children: buttons });
};
